import { makeStyles } from '@material-ui/core';
import { map, size } from 'lodash';
import React from 'react';
import { Item } from '../ProductsModal';

const useStyle = makeStyles((theme) => ({
  itemsContainer: {
    marginTop: theme.spacing(2),
    position: 'relative',

    '& > * + *': {
      marginTop: theme.spacing(1),
    },
  },
}));

export default ({ data }) => {
  const { products, fridgeName } = data;
  const classes = useStyle();

  return (
    <>
      <div>
        <span>於</span>
        <span style={{ fontWeight: 'bold' }}>{` ${fridgeName} `}</span>
        <span>
          {
            size(products) === 0
              ? '的活動商品暫時完售，請等下次補貨:)'
              : '的適用商品如下：'
          }
        </span>
      </div>
      <div className={classes.itemsContainer}>
        {map(
          products,
          (product) => (
            <div key={product.id}>
              <Item data={product} />
            </div>
          )
        )}
      </div>
    </>
  );
};
